import React from 'react'
import styled from 'styled-components'

import { Error } from './Icons'

export const TAGS_TYPES = {
  FIRST_TIME_SENDER: 'FIRST_TIME_SENDER',
  BANNER_ADDED: 'BANNER_ADDED',
  VIP_IMPERSONATION: 'VIP_IMPERSONATION',
  VIP_IMPERSONATION_WITH_BORDER: 'VIP_IMPERSONATION_WITH_BORDER',
  LOW_RISK_GREEN: 'LOW_RISK_GREEN',
  LOW_RISK_YELLOW: 'LOW_RISK_YELLOW',
  LOW_RISK_RED: 'LOW_RISK_RED',
  VIP: 'VIP',
  NEW: 'NEW',
  NEW_HIRE: 'NEW_HIRE',
  BETA: 'BETA',
  LEGACY: 'LEGACY',
}

const TAG_PADDING = '2px 6px 1px 6px'

const StyledTag = styled.div.attrs((props) => ({
  id: props.id || 'tag',
}))`
  display: inline-flex;
  border-radius: 4px;
  font-family: var(--t-typography-font-family-font-family-default);
  font-size: var(--t-typography-font-size-2xs);
  font-weight: var(--semibold);
  padding: 2px 8px;
  line-height: 13px;
  .text {
    white-space: nowrap;
  }
`

const getTagConfig = (type) => {
  const configs = {
    [TAGS_TYPES.FIRST_TIME_SENDER]: {
      text: 'First Time Sender',
      style: {
        backgroundColor: 'var(--ds-gray-2)',
        color: 'var(--white)',
        textTransform: 'uppercase',
        fontSize: 'var(--t-typography-font-size-2xs)',
      },
    },
    [TAGS_TYPES.BANNER_ADDED]: {
      text: 'Banner Added',
      leftIcon: (
        <Error
          width="12px"
          height="12px"
          fill="var(--ds-gray-2)"
          style={{ margin: '0 7px 0 1px' }}
        />
      ),
      style: {
        backgroundColor: '#F3F3F3',
        color: 'var(--ds-gray-2)',
        textTransform: 'uppercase',
        fontSize: 'var(--t-typography-font-size-2xs)',
      },
    },
    [TAGS_TYPES.VIP_IMPERSONATION]: {
      text: 'VIP Impersonation',
      style: {
        backgroundColor: 'rgba(228, 66, 88, 0.10)',
        color: 'var(--negative-color)',
        fontSize: '12px',
        padding: TAG_PADDING,
      },
    },
    [TAGS_TYPES.VIP_IMPERSONATION_WITH_BORDER]: {
      text: 'VIP Impersonation',
      style: {
        backgroundColor: 'rgba(228, 66, 88, 0.10)',
        color: 'var(--negative-color)',
        fontSize: '12px',
        border: '1px solid rgba(228, 66, 88, 0.50)',
        height: '18px',
        padding: TAG_PADDING,
        boxSizing: 'border-box',
        alignItems: 'center',
      },
    },
    [TAGS_TYPES.LOW_RISK_GREEN]: {
      text: 'Low Risk',
      style: {
        backgroundColor: 'var(--t-opacity-success-10)',
        color: 'var(--positive-color)',
        fontSize: 'var(--t-typography-font-size-2xs)',
        textTransform: 'uppercase',
      },
    },
    [TAGS_TYPES.LOW_RISK_YELLOW]: {
      text: 'Low Risk',
      style: {
        backgroundColor: 'var(--t-opacity-warning-20)',
        color: 'var(--warning-color)',
        fontSize: 'var(--t-typography-font-size-2xs)',
        textTransform: 'uppercase',
      },
    },
    [TAGS_TYPES.LOW_RISK_RED]: {
      text: 'Low Risk',
      style: {
        backgroundColor: 'rgba(228, 66, 88, 0.10)',
        color: 'var(--negative-color)',
        fontSize: 'var(--t-typography-font-size-2xs)',
        textTransform: 'uppercase',
      },
    },
    [TAGS_TYPES.VIP]: {
      text: 'VIP',
      style: {
        color: 'var(--primary)',
        textTransform: 'uppercase',
        border: `1px solid var(--primary)`,
        backgroundColor: 'var(--ds-gray-8)',
        padding: TAG_PADDING,
        fontSize: '12px',
        lineHeight: '12px',
      },
    },
    [TAGS_TYPES.NEW]: {
      text: 'New',
      style: {
        /* Match light-theme --chart-yellow everywhere so the nav pill stays consistent in dark mode */
        backgroundColor: '#ffc55b',
        /* Same as light --neutral-color for this pair; do not use var(--neutral-color) in dark */
        color: '#003580',
        textTransform: 'uppercase',
        fontSize: '12px',
      },
    },
    [TAGS_TYPES.BETA]: {
      text: 'Beta',
      style: {
        backgroundColor: 'var(--links-color)',
        color: '#fff',
        textTransform: 'uppercase',
        fontSize: '12px',
      },
    },
    [TAGS_TYPES.NEW_HIRE]: {
      text: 'Triggered - New hire',
      style: {
        backgroundColor: 'var(--tag-new-hire-bg)',
        color: 'var(--tag-new-hire-text)',
        padding: '2.5px 6px 2.5px',
        fontSize: '12px',
      },
    },
    [TAGS_TYPES.LEGACY]: {
      text: 'Legacy',
      style: {
        backgroundColor: 'var(--t-opacity-warning-20)',
        color: 'var(--warning-color)',
        textTransform: 'uppercase',
        fontSize: '12px',
      },
    },
  }
  return configs[type]
}

const Tag = ({ id, className, type, text }) => {
  const tagConfig = getTagConfig(type)

  return (
    <StyledTag id={id} className={className} style={tagConfig.style}>
      {tagConfig.leftIcon}
      <span className="text">{text || tagConfig.text}</span>
    </StyledTag>
  )
}

export default Tag
